/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * RapidWorks.UserManagement.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { DatabaseInfoDto, GetApiUserManagementV1DatabasesParams, ProblemDetails } from '../model';

import { axiosInstance } from '../../axios-instance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getApiUserManagementV1Databases = (
  params?: GetApiUserManagementV1DatabasesParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<DatabaseInfoDto[]>({ url: `/api/user-management/v1/databases`, method: 'GET', params, signal }, options);
};

export const getGetApiUserManagementV1DatabasesQueryKey = (params?: GetApiUserManagementV1DatabasesParams) => {
  return [`/api/user-management/v1/databases`, ...(params ? [params] : [])] as const;
};

export const getGetApiUserManagementV1DatabasesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Databases>>,
  TError = ProblemDetails | void
>(
  params?: GetApiUserManagementV1DatabasesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Databases>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1DatabasesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1Databases>>> = ({ signal }) =>
    getApiUserManagementV1Databases(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1Databases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1DatabasesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserManagementV1Databases>>>;
export type GetApiUserManagementV1DatabasesQueryError = ProblemDetails | void;

export function useGetApiUserManagementV1Databases<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Databases>>,
  TError = ProblemDetails | void
>(
  params: undefined | GetApiUserManagementV1DatabasesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Databases>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1Databases>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1Databases>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1Databases<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Databases>>,
  TError = ProblemDetails | void
>(
  params?: GetApiUserManagementV1DatabasesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Databases>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1Databases>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1Databases>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1Databases<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Databases>>,
  TError = ProblemDetails | void
>(
  params?: GetApiUserManagementV1DatabasesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Databases>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1Databases<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Databases>>,
  TError = ProblemDetails | void
>(
  params?: GetApiUserManagementV1DatabasesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Databases>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1DatabasesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
